import { useMemo } from "react";
import { useResponsive } from "components/hooks/useResponsive";
import { BASE_COLORS } from "config/theme/constants";
import { SiderLogo } from "../SiderLogo";
import SiderMenu from "../SiderMenu";
import * as S from "./styles";

interface MainSiderProps {
  isCollapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const MainSider = ({ isCollapsed, setCollapsed, ...props }: MainSiderProps) => {
  const { isDesktop, mobileOnly, tabletOnly, isBigScreen } = useResponsive();

  const isCollapsible = useMemo(
    () => mobileOnly && tabletOnly,
    [mobileOnly, tabletOnly]
  );

  const toggleSider = () => setCollapsed(!isCollapsed);

  return (
    <S.Sider
      trigger={null}
      collapsed={!isDesktop && isCollapsed}
      collapsedWidth={tabletOnly ? 103 : isBigScreen ? 150 : 0}
      collapsible={isCollapsible}
      width={isBigScreen ? 150 : 103}
      {...props}
      style={{ background: BASE_COLORS.selago }}
    >
      <SiderLogo
        isSiderCollapsed={isCollapsed}
        toggleSider={toggleSider}
        setCollapsed={setCollapsed}
      />
      <SiderMenu setCollapsed={setCollapsed} />
    </S.Sider>
  );
};

export default MainSider;